import {
    getDataApi,
    postDataApi,
    deleteDataApi,
} from '../utils/fech-api';

const BASE_URL = '/api/media_objects'; 
const BASE_URL_ADMIN = '/api/admin/media_objects'; 

// Create a new image
export const createMedia = (postData, headers = {}) => {
    if (!(postData instanceof File)) {
        throw new Error('Invalid input: postData must be a File object.');
    }
    const formData = new FormData()
    formData.append('file',postData)
    return postDataApi(BASE_URL, formData, headers);
};

// Fetch all images
export const fetchMedias = async ({ pageParam = 1, params = {}, headers = {} }) => {
    const resp = await getDataApi(BASE_URL_ADMIN, headers, { ...params, 'order[id]': 'desc', page: pageParam });
    return ({
        data: resp.data,
        nextPage: resp.data.length > 0 ? pageParam + 1 : undefined,
    });
};

// Get an image
export const getOneMedia = (mediaId, headers = {}) => {
    return getDataApi(`${BASE_URL}/${mediaId}`, headers);
};

// Delete an image
export const deleteMedia = (mediaId, headers = {}, params = {}) => {
    return deleteDataApi(`${BASE_URL}/${mediaId}`, headers, params);
};
